import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useDispatch } from "react-redux";

import Login from "./Login.jsx";
import Summary from "./pages/Summary.jsx";
import Projectlevel from "./pages/Project_Kpi/Projectlevel.jsx";
import Comparison from "./pages/Project_Kpi/Comparison.jsx";
import SchemeDiversity from "./pages/Project_Kpi/SchemeDiversity.jsx";
import MilestoneSummary from "./pages/milestone/MilestoneSummary.jsx";

import ProtectedRoute from "./ProtectedRoute";
import { getSession } from "./utils/session";
import { setEmail, setProjectDetails } from "./userSlice";
import Project360accessManagement from "./ProjectAccess/Project360accessManagement.jsx";

const App = () => {
  const dispatch = useDispatch();

  // ✅ Restore session on refresh
  useEffect(() => {
    const session = getSession();

    if (session) {
      if (session.email) {
        dispatch(setEmail(session.email));
      }

      if (session.projectName && session.projectId) {
        dispatch(
          setProjectDetails({
            projectName: session.projectName,
            projectId: session.projectId,
            organizationName: session.organizationName,
          })
        );
      }
    }
  }, [dispatch]);

  return (
    <GoogleOAuthProvider clientId="1022617006188-cn0ni8r8fq9v45fpqutrrvme0v1tod6n.apps.googleusercontent.com">
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Login />} />

          {/* Protected */}
          <Route
            path="/Project-Summary"
            element={
              <ProtectedRoute>
                <Summary />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Project-Level"
            element={
              <ProtectedRoute>
                <Projectlevel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Project-KPI-Comparison"
            element={
              <ProtectedRoute>
                <Comparison />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Project-Scheme-Diversity"
            element={
              <ProtectedRoute>
                <SchemeDiversity />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Project-Milestone-Summary"
            element={
              <ProtectedRoute>
                <MilestoneSummary />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Project-access-management"
            element={
              <ProtectedRoute>
                <Project360accessManagement />
              </ProtectedRoute>
            }
          />



          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;